/* eslint-disable */
import React, {useState} from 'react';
import LineChart from '../../component/Inc/LineChart';
//component
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
//css
import 'contents/assets/scss/page/teacher.scss';
function Progress() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '수원시', cnt: '45', value: 0},
    {title: '고양시', cnt: '9898', value: 1},
    {title: '남양주시', cnt: '233', value: 2},
    {title: '구리시', cnt: '45', value: 3},
    {title: '광명시', cnt: '53', value: 4},
    {title: '광주시', cnt: '53', value: 5}
  ];
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  //진행타임
  const timelabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  const dataClassCount = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  const dataTime = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //인계
  const dataTime2 = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#2bce71',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //중단
  const dataTime3 = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#8f55ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //종료
  const dataTime4 = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#6d747f',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  return (
    <main className="com_container p_teacher_progress">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_7 active">교사별 진행 상태</h2>
          <article className="com_board_search">
            <div className="com_btn_wrap">
              <button className="com_btn line gray s active">오늘</button>
              <button className="com_btn line gray s">주간</button>
              <button className="com_btn line gray s">월간</button>
            </div>
            <div className="date_wrap">
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              <span className="divider"> ~ </span>
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              <button className="com_btn gray s">조회</button>
            </div>
          </article>
        </section>
        <section className="com_pg_container">
          <div className="box">
            <div className="com_board_list__top">
              <select className="select">
                <option>본사</option>
              </select>
              <article className="search">
                <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <button className="com_btn s lightGray">내 교사(58)</button>
            </div>
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">중2이하</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">중3</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">고1</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">고2</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">고3</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06" className="com_red_txt">
                    N수
                  </label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5.7%" />
                <col width="11%" />
                <col width="12.6%" />
                <col width="11%" />
                <col width="11%" />
                <col width="11%" />
                <col width="11%" />
                <col width="11%" />
                <col width="11%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>영역</th>
                  <th>교사</th>
                  <th>진행수업 수</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    진행타임
                  </th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    취소
                  </th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    인계
                  </th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    중단
                  </th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    종료
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>456</td>
                  <td>수학</td>
                  <td>
                    <span className="btn_link">홍길동103</span>
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>456</td>
                  <td>수학</td>
                  <td>
                    <span className="btn_link">홍길동103</span>
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </div>
          <div className="box">
            <article className="com_detail_top">
              <div className="info">
                <p className="tit">홍선생103(과탐)</p>
              </div>
              <button className="com_btn orange s btn_plus">수업 추가</button>
            </article>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="detail_tit dot">수업 수</div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_blue"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={dataClassCount} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="detail_tit dot">진행타임</div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_blue"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={dataTime} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="detail_tit dot">인계</div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_green"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={dataTime2} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="detail_tit dot">중단</div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_indigo"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={dataTime3} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="detail_tit dot">종료</div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_gray"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={dataTime4} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Progress;
